const CrossBlackIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.94872 17.3332L0.666672 16.0511L7.71795 8.99984L0.666672 1.94855L1.94872 0.666504L9 7.71779L16.0513 0.666504L17.3333 1.94855L10.2821 8.99984L17.3333 16.0511L16.0513 17.3332L9 10.2819L1.94872 17.3332Z" fill="#64648C"/>
        </svg>
	);
};

export default CrossBlackIcon;